<div class="predefined-charts-container">
  @if (!payload?.start_date || !payload?.end_date) {
    <div class="overall-error no-payload">
      <p>Select a date range to load charts.</p>
    </div>
  } @else if (overallError) {
    <div class="overall-error">
      <p>{{ overallError }}</p>
      <button type="button" class="retry-btn" (click)="refresh()">Retry</button>
    </div>
  } @else if (expandedChartId) {
    <div class="go_back_class">
      <span (click)="goBack()">
        <button type="button">
          <img src="assets/icons/go_back.svg" alt="Go Back" />
        </button>
        <span>Go back to all charts</span>
      </span>
    </div>
    <div class="chart-container custom-chart-container">
      @if (getExpandedDefinition(); as def) {
        <app-predefined-chart
          [chartId]="def.id"
          [chartTitle]="def.title"
          [chartData]="getChartData(def.id)"
          [loading]="isLoadingChart(def.id)"
          [errorMessage]="getChartError(def.id)"
          [isLargeView]="true"
          [showGranularityDropdown]="isAreaChart(def.id) && isSingleDayDateRange()"
          [granularityOptions]="bucketGranularityOptions"
          [selectedGranularityHours]="bucketGranularityHours"
          (granularityChange)="onBucketGranularityChange($event)"
          (viewInLarge)="expandChart($event)"
        />
      }
    </div>
  } @else {
    <div class="charts-grid">
      @for (def of definitions; track def.id) {
        <app-predefined-chart
          [chartId]="def.id"
          [chartTitle]="def.title"
          [chartData]="getChartData(def.id)"
          [loading]="isLoadingChart(def.id)"
          [errorMessage]="getChartError(def.id)"
          [showGranularityDropdown]="isAreaChart(def.id) && isSingleDayDateRange()"
          [granularityOptions]="bucketGranularityOptions"
          [selectedGranularityHours]="bucketGranularityHours"
          (granularityChange)="onBucketGranularityChange($event)"
          (viewInLarge)="expandChart($event)"
        />
      }
    </div>
  }
</div>
